module.exports = __webpack_public_path__ + "img/icon_logotype.6621ee5.svg";